// extracted by mini-css-extract-plugin
export default {"targetContainer":"CareElementsConfiguration_targetContainer__+BVK9"};